export default {
  title: 'Acesso ao Suporte',
  username: 'Usuário:',
  password: 'Senha:',
  nif: 'NIF:',
  promoterCode: 'Promotora:',
  button: 'Entrar',
  impersonateUsername: 'Usuário a ser substituído',
  selectImpersonateUsername: 'Por favor, selecione o usuário a ser substituído',
  validate: {
    username: 'Usuário',
    password: 'Senha',
    nif: 'NIF',
    appUser: 'Usuário Oauth2',
    appPassword: 'Senha Oauth2'
  },
  environment: 'Ambiente',
  issues: {
    title: 'Suporte técnico',
    subject: 'Assunto',
    email: 'Email',
    comments: 'Comentários',
    send: 'Enviar',
    cancel: 'Cancelar',
    success: 'O problema foi informado. O título e o número do caso são:',
    getError: 'Serviço não disponível. Por favor, tente novamente mais tarde ou entre em contato conosco em:',
    reportError: 'Desculpe. Ocorreu um erro ao enviar o caso. Por favor, tente novamente mais tarde ou entre em contato conosco em:',
    validationError: 'Dados inválidos',
    search: {
      title: 'Busca',
      from: 'De',
      to: 'Até',
      number: 'Número do caso',
      status: 'Estado'
    },
    headers: {
      created: 'Criado',
      number: 'Número',
      subject: 'Assunto',
      status: 'Estado'
    },
    status: {
      active: 'Ativo',
      resolved: 'Resolvido',
      closed: 'Fechado',
      reactivated: 'Reativado',
      any: 'Qualquer'
    }
  }
}